<template>
<div class="chapter">
<div class="inner_page">
<p class="halftitle"><a id="page_xv">T<span class="small">HE</span> E<span class="small">IGHTEENTH</span>-C<span class="small">ENTURY</span> F<span class="small">ORTEPIANO</span> G<span class="small">RAND</span> <i>and</i> I<span class="small">TS</span> P<span class="small">ATRONS</span></a></p><a id="page_xv">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 08_Fm01.vue?81d79b46